



























































































































































import Vue, { PropType } from "vue";
import { AvailabilityOfOptionsInterface } from "@/model/components/AvailabilityOfOptionsInterface.ts";
import { NthOrderInterface } from "@/model/components/NthOrderInterface.ts";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { optionCardCaseShow, optionTraceShow } from "@/model/views/display.ts";

export default Vue.extend({
  name: "AvailabilityOfOptions",

  mixins: [validationMixin],

  props: {
    availabilityOfOptions: {
      type: Object as PropType<AvailabilityOfOptionsInterface>
    },
    numberOfPrints: {
      type: Number as PropType<undefined | number>
    },
    newNthOrderList: {
      type: Array as PropType<NthOrderInterface[]>
    },
    frontSideLogo: {},
    backSideLogo: {},
    freeBackSideLogo: {}
  },

  validations: {
    businessCardCase: { required },
    roundShapeProcessing: { required },
    logoTrace: { required }
  },

  computed: {
    businessCardCase(): string {
      return this.availabilityOfOptions.businessCardCase;
    },
    roundShapeProcessing(): string {
      return this.availabilityOfOptions.roundShapeProcessing;
    },
    logoTrace(): string {
      return this.availabilityOfOptions.logoTrace;
    },
    siteUrl(): string {
      return process.env.VUE_APP_SITE_URL;
    },

    isBusinessCardCaseShow(): boolean {
      return optionCardCaseShow([
        { numberOfPrints: Number(this.numberOfPrints) },
        ...this.newNthOrderList
      ]);
    },
    isLogoTraceShow(): boolean {
      return optionTraceShow(
        Boolean(this.frontSideLogo),
        Boolean(this.backSideLogo),
        Boolean(this.freeBackSideLogo)
      );
    }
  },

  methods: {
    validation(label: string): boolean {
      if (!label) {
        this.$v.$touch();
      } else {
        this.$v[label].$touch();
      }
      return !this.$v.$invalid;
    },
    updateAvailabilityOfOptions(value: string, label: string): void {
      this.validation(label);
      this.$emit(
        "updateAvailabilityOfOptions",
        Object.assign({}, this.availabilityOfOptions, { [label]: value })
      );
    }
  }
});
